import { DrawerId, FormId } from "components/CC/types/models.ts";
import { BaseConnectionCreatorDrawer } from "components/CC/UI/BaseConnectionCreatorDrawer.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation.tsx";

import { WaitForm } from "../Forms/WaitForm.tsx";

export const WaitDrawer = () => {
    const { t } = usePaldockTranslation("components.connection-creator");

    return (
        <BaseConnectionCreatorDrawer drawerId={DrawerId.Wait} title={t("nodes.wait.drawers.title")}>
            <WaitForm formId={FormId.WaitForm} />
        </BaseConnectionCreatorDrawer>
    );
};
